// create separate utils folder if need to export more utils

type DataNode = {
	version?: number;
	type: string;
	text?: string;
	attrs?: unknown;
	marks?: DataNode[];
	content?: DataNode[];
};

const validMarks = (data: DataNode) => {
	const invalidMarks = ['annotation', 'link'];
	return !data.marks || !data.marks.some((mark) => invalidMarks.includes(mark.type));
};
const validType = (data: DataNode) => {
	const invalidTypes = ['codeBlock'];
	return !invalidTypes.includes(data.type);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const extractContent = (data: any, flatMap: DataNode[]) => {
	if (validType(data)) {
		if (data.content && data.content.length > 0) {
			for (const node of data.content) {
				extractContent(node, flatMap);
			}
		}
	}
	// leaf node
	if (data.type === 'text' && validMarks(data)) {
		flatMap.push(data);
	}
};

export const parseContent = (adfValue: unknown): string => {
	const flatMap: DataNode[] = [];
	extractContent(adfValue, flatMap);
	return flatMap.map((node) => node.text).join(',');
};
